import { Directive, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType } from '@ngx-formly/core';
import { MonoTypeOperatorFunction } from 'rxjs';

@Directive()
export class FormlyFieldBaseComponent extends FieldType {
  protected readonly destroyRef = inject(DestroyRef);

  protected untilDestroyed<T>(): MonoTypeOperatorFunction<T> {
    return takeUntilDestroyed<T>(this.destroyRef);
  }

  get key(): string {
    return this.field.key as string;
  }

  get valid(): boolean {
    return (this.formControl.dirty || this.formControl.touched) && !this.showError && this.useValidation;
  }

  get invalid(): boolean {
    return this.showError && this.useValidation;
  }

  get useValidation(): boolean {
    return !this.props.readonly && !this.props.required;
  }

  get hasValidation(): boolean {
    return (
      this.field.validators.validation.length > 0 ||
      Object.keys(this.field.validators).filter((x) => x !== 'validation').length > 0
    );
  }
}
